import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import PageLoader from '../../../../../components/PageLoader';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { selectCategoriesListItems } from '../../../../../redux/categories/selector';
import { categories } from '../../../../../redux/categories/action';
import { products } from '../../../../../redux/products/action';
import { selectListItems } from '../../../../../redux/library/selector';
import * as R from 'ramda'
import { selectOrganizationUnitsListItems } from '../../../../../redux/organizationUnits/selector';
import { selectTenantFunctionsListItems } from '../../../../../redux/tenant-functions/selector';
import { tenantFunctions } from '../../../../../redux/tenant-functions/action';
import { websites } from '../../../../../redux/websites/action';
import { accountWebPages } from '../../../../../redux/web-pages/action';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import { selectAccountWebPagesListItems } from '../../../../../redux/web-pages/selector';
import { accounts } from '../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { organizationUnits } from '../../../../../redux/organizationUnits/action';

import { selectTemplatesListItems } from '../../../../../redux/templates/selector';
import storePersist from '../../../../../redux/storePersist';
import { selectProductsListItems } from '../../../../../redux/products/selector';
import { orgRegistries } from '../../../../../redux/org-registries/action';
import { selectOrgRegistriesListItems } from '../../../../../redux/org-registries/selector';
import { selectDbasListItems } from '../../../../../redux/dbn-cloud/dbas/selector';
import { dbas } from '../../../../../redux/dbn-cloud/dbas/action';
import { selectAccountTypesListItems } from '../../../../../redux/account-types/selector';
import { accountTypes } from '../../../../../redux/account-types/action';
import { ListCriteria } from '../../../../types/list-criteria';
import { selectPollsQueryItems } from '../../../../../redux/polls/selector';
import PollsComponent from '../components/polls.component';
import { polls } from '../../../../../redux/polls/action';
import { communities } from '../../../../../redux/community/action';
import { chapter } from '../../../../../redux/chapter/chapters/action';
import { selectChapterListItems } from '../../../../../redux/chapter/chapters/selector';
import { selectCommunitiesListItems } from '../../../../../redux/community/selector';
import { topics } from '../../../../../redux/chapter/topics/action';
import { selectTopicsListItems } from '../../../../../redux/chapter/topics/selector';

let currentChange: any = {}
const ManagementPoll = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const params: any = useParams();
    const { getUploadFiles } = useAppSelector(selectCurrent)
    const categoriesLists = useSelector(selectCategoriesListItems)
    const productsLists = useSelector(selectProductsListItems)
    const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
    const tenantfunctionsLists = useSelector(selectTenantFunctionsListItems)
    const channelLists = useSelector(selectListItems)
    const templatesItems = useSelector(selectTemplatesListItems)
    const websitesItems = useSelector(selectWebsitesListItems)
    const webPagesItems = useSelector(selectAccountWebPagesListItems)
    const orgRegistryItems = useSelector(selectOrgRegistriesListItems)
    const dbasItems = useSelector(selectDbasListItems)
    const comunityItems = useSelector(selectCommunitiesListItems)
    const chapterItems = useSelector(selectChapterListItems)
    const topicsItems = useSelector(selectTopicsListItems)
    const queryItem = useSelector(selectPollsQueryItems);
    const libraryData = useSelector(selectListItems)
    const [accountTypesList, setAccountTypesList] = useState<any>([]);
    const [associatedAccountTypeId, setAssociatedAccountTypeId] = useState<number | undefined>();
    const [ownerLevelId, setOwnerLevelId] = useState<number | undefined>();
    const accountItems = useSelector(selectAccountsListItems)
    const accountTypeItems = useSelector(selectAccountTypesListItems)
    const [accountsList, setAccountsList] = useState<any>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const TypeData = libraryData?.result?.Type
    const [selectPolls, setSelectPolls] = useState<any>({});
    const parmas: any = useParams()


    const librariesItems = storePersist?.get("library")?.current;
    const [isQuery, setIsQuery] = useState<boolean>(false)

    const [
        selectedFunctions,
        setSelectedFunctions
    ] = useState<any>([])

    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>([])

    const listAccountTypes = async () => {
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBAAccountTypes = async () => {
        // v6.1/organization/dbn/dba-type-dba-mappings
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBNBizAccountTypes = async () => {
        // v6.1/organization/dbn/biz-net-types
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/biz-net-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listAccountsByType = async ({ searchCriteria, filterCriteria, dateCriteria }: ListCriteria) => {
        await dispatch(accounts.resetAction({ actionType: 'list' }))
        await dispatch(accounts.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
            entity: 'accounts',
            jsonData: {
                "Filters": filterCriteria,
                "Searches": searchCriteria,
                "DateCriteria": dateCriteria,
            }
        }))
    }



    const fetchLMSLearningPathsQueryById = () => {
        dispatch(polls.query({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/polls/fetch-detail`,
            entity: 'polls',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: parmas?.id,
                    },
                ],
            },
        })).then(() => {
            setIsQuery(true);
        });
    };

    useEffect(
        () => {
            dispatch(websites.list({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'cards', jsonData: {
                }
            })).then(() => {
                dispatch(accountWebPages.list({
                    url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {
                    }
                }))
            }).then(() => {
                dispatch(categories.list({
                    url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
                    entity: 'categories',
                    jsonData: {

                    }
                }))
            }).then(() => {
                dispatch(products.list({
                    url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/catalog/products/list`,
                    entity: 'products',
                    jsonData: {
                    }
                }))
            }).then(() => {
                dispatch(communities.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/list`,
                    entity: 'communities',
                    jsonData: {
                    }
                }))
            }).then(() => {
                dispatch(chapter.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapters/list`,
                    entity: 'chapter',
                    jsonData: {
                    }
                }))
            }).then(() => {
                dispatch(topics.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topics/list`,
                    entity: 'topics',
                    jsonData: {
                    }
                }))
            }).then(() => {
                dispatch(dbas.list({
                    url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/dbas/list`,
                    entity: 'dbas',
                    jsonData: {

                    }
                }))
            }).then(() => {
                dispatch(orgRegistries.list({
                    url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/org-registries/fetch`,
                    entity: 'orgRegistries',
                    jsonData: {
                        "Context": {},
                        "Records": [{ IsBothTenantANDDBNBased: true }],
                        "Pagination": {

                        }
                    }
                }))
            }).then(() => {
                dispatch(accounts.list({
                    url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/fetch`,
                    entity: 'accounts',
                    jsonData: {
                        Context: {},
                        Records: [
                            {
                                IsProxyAccount: false
                            }
                        ],
                        Pagination: {
                        }

                    }
                }))
            }).then(() => {
                dispatch(tenantFunctions.list({
                    url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`, entity: 'tenantDomainFunctions', jsonData: {
                        Filters: [
                            {
                                FieldName: 'IsTemplateMappingEnabled',
                                FieldText: 'TemplateMappingEnabled',
                                FieldType: 'boolean',
                                FilterOperatorId: 1,
                                FieldValue: true
                            }
                        ]


                    }
                }))
            })
            dispatch(organizationUnits.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {

                }
            }));
            if (params?.id > 0) {
                fetchLMSLearningPathsQueryById()
                setIsLoading(false)
            }
            else {
                const localSelectedFunction = addNewRow({ selectedFunctionArg: selectedFunctions });
                setSelectedFunctions(localSelectedFunction)


                setIsLoading(false)
            }
        },
        []
    )


    useEffect(
        () => {

            if (isQuery) {
                setSelectPolls(queryItem?.result?.items)
                const localSelectedService = addNewRow({ selectedFunctionArg: queryItem?.result?.items?.MappedEntities });
                setSelectedFunctions(localSelectedService)


            }
        },
        [isQuery]
    )
    const handleFormAttachmentItemChange: any = ({ value, field, idx }: any) => {
        const items = deepCopy(mediaFiles);// deep copy of grn items
        let item = items[idx];// deep copy of item to be edited
        item = { ...item, [field]: value }// updated the particular item
        items[idx] = item;
        currentChange = { value, field, idx }
        setMediaFiles(items);
    }

    const deleteSelectedFunctions = async (Item: any, index: any) => {
        if (Item.Id === 0) {
            selectedFunctions?.splice(
                index,
                1
            )
        }
        handleClose()
    }
    const addNewRow = ({ selectedFunctionArg }: any) => {
        const localSelectedFunction = deepCopy(selectedFunctionArg)
        const newsFunctions = {
            Id: 0,
            OwnerTypeId: 0,
            OwnerId: 0,

        }
        if (localSelectedFunction.length === 0 ||
            localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerTypeId !== 0 ||
            localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerId !== ''

        ) {
            localSelectedFunction?.push(newsFunctions)
        }

        return localSelectedFunction
    }
    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectPolls({ ...selectPolls, [field]: event });
    }
    const handleFormItemChange: any = ({ value, field, idx }: any) => {
        const items = deepCopy(selectedFunctions);// deep copy of grn items
        let item = items[idx];// deep copy of item to be edited
        item = { ...item, [field]: value }// updated the particular item
        items[idx] = item;
        currentChange = { value, field, idx }
        setSelectedFunctions(items);
    }







    const handleClose = () => {
        dispatch(settings.set({ getUploadFiles: 'close' }))

    }

    useEffect(() => {
        setAssociatedAccountTypeId(selectPolls?.OwnerTypeId);
        setOwnerLevelId(selectPolls?.OwnerLevelId);
    }, [selectPolls]);

    useEffect(() => {
        if (associatedAccountTypeId && accountTypesList) {
            const accountTypeName = accountTypesList?.find(
                (item: any) => item.Id === associatedAccountTypeId
            )?.Name;
            const accountTypeValue = TypeData.find(
                (type: any) => type.Text === accountTypeName
            )?.Text;
            if (accountTypeValue) {
                listAccountsByType({
                    filterCriteria: [{
                        "FieldName": "Type",
                        "FilterOperatorId": 6,
                        "FieldValue": accountTypeValue,
                        "FieldType": "text"
                    }]
                })
            }
        }
    }, [accountTypesList, associatedAccountTypeId]);



    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                listAccountTypes();
                break;
            case 11:
                listDBAAccountTypes();
                break;
            case 12:
                listDBNBizAccountTypes();
                break;
            default:
                dispatch(accountTypes.resetAction({ actionType: 'list' }))
                break;

        }
    }, [ownerLevelId]);

    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                setAccountTypesList(accountTypeItems?.result?.items);
                setAccountsList([]);
                break;
            case 11:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.Id, Name: o?.Name } }));
                setAccountsList([]);
                break;
            case 12:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.IEAccountTypeId, Name: o?.IEAccountTypeName } }));
                setAccountsList([]);
                break;
            default:
                setAccountTypesList([]);
                setAccountsList([]);
                break;

        }
    }, [accountTypeItems]);

    useEffect(() => {
        dispatch(accounts.resetAction({ actionType: 'list' }))
        setAccountsList([])
    }, []);

    useEffect(() => {
        setAccountsList(accountItems?.result?.items || [])
    }, [accountItems]);


    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        selectPolls.IsApproved = true;
        selectedFunctions.splice(
            selectedFunctions.length - 1,
            1
        );
        mediaFiles?.splice(
            mediaFiles.length - 1,
            1
        )

        const mediaData: any = mediaFiles?.map((item: any) => {
            const itemData = {
                attachementURL: item?.FileMappingURL
            }
            return itemData
        })


        selectPolls.MappedEntities = selectedFunctions

        const eventData = {


            "Id": selectPolls?.ResourceId || 0,
            "Title": selectPolls?.Title,
            "Description": selectPolls?.Description,
            "ExpiresAt": selectPolls?.ExpiresAt,
            "OwnerLevelId": selectPolls?.OwnerLevelId || 0,
            "OwnerTypeId": selectPolls?.OwnerTypeId || 0,
            "OwnerAccountId": selectPolls?.OwnerAccountId || 0,
            "OwnerType": selectPolls?.OwnerType || '',
            "OwnerAccountName": selectPolls?.OwnerAccountName || '',
            "PollTypeId": selectPolls?.PollTypeId || 0,
            "OwnerLevel": selectPolls?.OwnerLevel || '',
            "IsApproved": selectPolls?.IsApproved,
            "MappedEntities": selectPolls?.MappedEntities,
        }

        if (parmas?.id > 0) {
            await dispatch(polls.resetAction({ actionType: 'update' }))
            await dispatch(polls.update({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/polls`,
                entity: 'polls',
                jsonData: {
                    Context: {},
                    Records: [eventData],
                },
            })).then(() => {
                back();
            });
        } else {
            await dispatch(polls.resetAction({ actionType: 'create' }))
            await dispatch(polls.create({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/polls`,
                entity: 'polls',
                jsonData: {
                    Context: {},
                    Records: [eventData],
                },
            })).then(() => {
                back();
            });
        }
    }

    const setCombinationInfo = async () => {
        let localSelectedFunction = deepCopy(selectedFunctions)
        localSelectedFunction.splice(
            currentChange.idx,
            1,
            { ...localSelectedFunction[currentChange.idx] }
        );
        localSelectedFunction = addNewRow({ selectedFunctionArg: localSelectedFunction });
        currentChange.field = 'OwnerTypeIdDONE'
        setSelectedFunctions(localSelectedFunction)
    }

    useEffect(
        () => {
            if (currentChange.field === 'OwnerId') {
                setCombinationInfo()
            }
        },
        [selectedFunctions]
    )
    const back = () => {
        navigate('/management/cms/polls')
    }

    useEffect(() => {

    }, [selectPolls]
    )


    const formatWebpagesListData = (data: any) => {
        return _.map(data, (product: any) => {
            const item = {
                Id: product?.Id,
                WebpageName: `${product?.Name} : ${product?.AccountName}`,
            };
            return item
        });
    };
    return (
        <>

            {isLoading ? <PageLoader /> :
                <PollsComponent
                    handleInnerFormChange={handleInnerFormChange}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    selectPolls={selectPolls}
                    anounceMentType={librariesItems?.anounceMentType}
                    selectedFunctions={selectedFunctions}
                    categories={categoriesLists?.result?.items}
                    accounts={accountItems?.result?.items}
                    channels={channelLists?.result?.items}
                    organizationUnits={organizationUnitsLists?.result?.items}
                    dbas={dbasItems?.result.items}
                    orgRegistries={orgRegistryItems?.result.items}
                    products={productsLists?.result?.items}
                    handleFormItemChange={handleFormItemChange}
                    deleteSelectedFunctions={deleteSelectedFunctions}
                    tenantFunction={tenantfunctionsLists?.result?.items}
                    templates={templatesItems?.result?.items}
                    id={parmas?.id}
                    accountTypesListLoading={accountTypeItems?.isLoading}
                    comunityList={comunityItems?.result?.items}
                    chapterList={chapterItems?.result?.items}
                    topicsList={topicsItems?.result?.items}
                    accountTypesList={accountTypesList}
                    accountListLoading={accountItems?.isLoading}
                    policyOwnerType={libraryData?.result?.PolicyOwnerType}
                    PollTypeList={libraryData?.result?.PollType}
                    resourceAccessLevel={libraryData?.result?.ResourceAccessLevel}
                    accountsList={accountsList}
                    isLoading={isLoading}
                    mediaFiles={mediaFiles}
                    handleFormAttachmentItemChange={handleFormAttachmentItemChange}
                    websites={websitesItems?.result?.items}
                    webpages={formatWebpagesListData(webPagesItems?.result?.items)}
                    tenantFunctions={(tenantfunctionsLists?.result?.items || []).flatMap(
                        (func: any) =>
                            (func.Entities || []).map((entity: any) => ({
                                label: entity.EntityName,       // what to show in dropdown
                                value: entity.Id,               // OwnerTypeId
                                FunctionName: func.FunctionName, // used for conditional logic
                            })))}

                />}
        </>
    )

}

export default ManagementPoll;